module.exports = __webpack_public_path__ + "media/images/emoticons/end-818c2740e4803e3d3fa35e309c8f309b.gif";